$ ->
  document.addEventListener 'turbojs:change', ->
    $('.twitter-share-button').each (i, el) ->
      $(el).attr 'data-url', document.location.toString()
      $(el).attr 'data-text', document.title